<template>
  <div class="breadcrumb">
    <ul>
      <!-- <i  
        class= "fa fa-arrow-circle-left is-link" aria-hidden="true"
        @click="detailPage()"
      >
      </i> -->
      <li
        v-for="(breadcrumb, idx) in breadcrumbList"
        :key="idx"
        @click="routeTo(idx)"
        class="is-link"
        >

        {{ getName(breadcrumb)  }}

      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  data () {
    return {
      breadcrumbList: [
        // {name: "L&I dashboard", link: '/' },
        // {name: "Property history", link: '/Property-History'},
      ]
    }
  },
  mounted () { this.updateList() },
  watch: { '$route' () { this.updateList() } 
  },
  methods: {
    routeTo (pRouteTo) {
        console.log("pRouteTo:", pRouteTo);
        if( this.breadcrumbList[pRouteTo].detailPage){
            this.detailPage(pRouteTo);
        }
        if (this.breadcrumbList[pRouteTo].link) {this.$router.push(this.breadcrumbList[pRouteTo].link)}
    },
    updateList () { 
        // this.$route.meta.breadcrumb.forEach(a => console.log(a))
        // console.log(this.$route)
        let address = "";
        if (this.$store.state.searchResults) {
          address = this.$store.state.searchResults.opa_address !== "" ? this.$store.state.searchResults.opa_address : this.$store.state.searchResults.street_address;
        } 
        this.$route.name === 'search-error' || this.$route.name === 'search-error' ? "" :
        this.$route.meta.breadcrumb.name === 'Search results: ' ? this.$route.meta.breadcrumb.name = address : 
        this.$route.meta.breadcrumb.name === 'Contractor Permit Results' ? this.$route.meta.breadcrumb.name = this.$route.query.searchTerm : 
        "";
        this.breadcrumbList = [];
        this.$route.meta.breadcrumb.forEach(a => this.breadcrumbList.push(a))
    },
    detailPage(pRouteTo){
      console.log("Breadcrumb: ", this.breadcrumbList[pRouteTo])
      this.$store.commit('closeDetail');
      // this.$router.go(-1);
      // this.$router.push(this.$store.state.searchResults.opa_address)
      if (this.breadcrumbList[pRouteTo].name === 'Search results: ') {
        this.$router.push(
           { name: 'address-search',
             query: { address: this.$store.state.searchResults.opa_address !== "" ? this.$store.state.searchResults.opa_address : this.$store.state.searchResults.street_address},
           }).catch(()=>{})
      }
      if (this.breadcrumbList[pRouteTo].name === 'Contractor Permit Results: ') {
        this.$router.push(
           { name: 'contractorPermitSearch',
             query: { searchTerm: this.$route.query.searchTerm, Id: null},
           }).catch(()=>{})
      }
      if (this.breadcrumbList[pRouteTo].name === "Appeals Calendar") {
        let calendarQuery = this.$route.query
        delete calendarQuery.Id;
        this.$router.push(
           { name: 'appeals-calendar',
             query: calendarQuery
           }).catch(()=>{})
      }
      if (this.breadcrumbList[pRouteTo].name === "ZBA Appeals Calendar") {
        let calendarQuery = this.$route.query
        delete calendarQuery.Id;
        this.$router.push(
           { name: 'zba-appeals-calendar',
             query: calendarQuery
           }).catch(()=>{})
      }
    },
    getName(breadcrumb){
        // console.log(breadcrumb)
        let address = "";
        if(this.$store.state.searchResults){
          address = this.$store.state.searchResults.opa_address !== "" ? this.$store.state.searchResults.opa_address : this.$store.state.searchResults.street_address;
        }
        return breadcrumb.name === 'Search results: ' && this.$store.state.searchResults ?
        address : 
          this.getID(breadcrumb) ? breadcrumb.name + this.getID(breadcrumb) : breadcrumb.name
    },
    getID(breadcrumb){
      // console.log("breadcrumb: ", breadcrumb.name, this.$store.state.detailPage);

      let address = "";
      if(this.$store.state.searchResults){
        address = this.$store.state.searchResults.opa_address !== "" ? this.$store.state.searchResults.opa_address : this.$store.state.searchResults.street_address;
      }
      return  breadcrumb.name === 'Search results: ' && this.$store.state.searchResults ? address :
              breadcrumb.name === 'Contractor Permit Results: ' ? this.$route.query.searchTerm :
              breadcrumb.name === 'Permit Detail: ' ? this.$route.query.Id :
              breadcrumb.name === 'License Violation: ' ? this.$route.query.Id :
              breadcrumb.name === 'Permit: ' ? this.$route.query.Id :
              breadcrumb.name === 'Violation: ' ? this.$route.query.Id :
              breadcrumb.name === 'Appeal: ' ? this.$route.query.Id :
              breadcrumb.name === 'Business license: ' ? this.$route.query.Id : ''
            },
  }
}
</script>

<style lang="scss" scoped>

@media screen and (max-width: 768px) {
      div.breadcrumb {
      margin: 0.5rem 0;
      display: flex;
      ul {
        justify-content: left;
        padding-top: 15px;
        padding-left: 15px;
        li {
          margin-bottom: 10px;
        }
    }
    }
}
@media screen and (min-width: 768px) {
      div.breadcrumb {
        margin: 2.5rem 0 0.5rem 0;
        display: flex;
      }
}

    i.fa-arrow-circle-left {
        margin-right: 6px;
        top: -3px;
        position: relative;
        cursor: pointer;
    }
    div>div.breadcrumb {
        ul>.is-link:hover {
            background-color: transparent;
            border-color: unset;
            color: $grey-dark !important;
        }
    }
    ul {
        display: flex;
        justify-content: center;
        list-style-type: none;
        margin: 0;
        padding: 0;
    }
    ul > li {
        display: flex;
        float: left;
        height: 10px;
        padding-right: 5px;
        width: auto;
        font-weight: bold;
        font-size: .8em;
        cursor: pointer;
        align-items: center;
        &::before{
            padding-right: 5px;
        }
        &:last-child {
          color: $grey-dark;
          &:last-child:hover {
            color: $grey-dark !important;
            background-color: transparent !important;
          }
        }
    }
    .linked {
        cursor: pointer;
        font-size: 1em;
        font-weight: normal;
    }
</style>